// src/config/fetchNavConfig.js
import { getRoleToPageAccess, getUserRole } from "./apiService";

const slugify = (str) =>
  decodeURIComponent(str)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/&/g, "and")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/--+/g, "-")
    .trim();

export const fetchNavConfig = async (account) => {
  if (!account) return [];
  try {
    // 1️⃣ Get all report/page access from backend
    const reportData = await getRoleToPageAccess();
    const userRoleResponse = await getUserRole(); // e.g., [{ Userid, Role }]
    const username = account.username.trim().toLowerCase();
    const usernamePrefix = (username || "").split("@")[0].trim().toLowerCase();

    const match = userRoleResponse.find(
      (u) => (u.Userid || "").split("@")[0].trim().toLowerCase() === usernamePrefix
    );

    const currentRole = match ? match.Role : null;

    // 3️⃣ Filter reports/pages based on role
    const dashboardMap = {};

    reportData.forEach(entry => {
      if (!entry.Role || entry.Role !== currentRole) return; // skip if role doesn't match

      const dashKey = entry.dashboard;
      const reportSlug = slugify(entry.report);

      if (!dashboardMap[dashKey]) {
        dashboardMap[dashKey] = { label: dashKey, reports: [] };
      }

      const reportObj = dashboardMap[dashKey].reports.find(r => r.name === entry.report);

      const pages = [{
        name: entry.page_name,
        route: `/${slugify(dashKey)}/${reportSlug}/${slugify(entry.page_name)}`,
        sectionId: entry.sectionId,
        rlsEnabled: entry.rlsEnabled,
      }];

      if (reportObj) {
        reportObj.pages.push(...pages);
      } else {
        dashboardMap[dashKey].reports.push({
          name: entry.report,
          pages,
        });
      }
    });

    return Object.values(dashboardMap);
  } catch (err) {
    console.error("Failed to fetch nav config", err);
    return [];
  }
};
